// Cross-component live-update signal for the Active Events panel.
// Any felt-report form calls notifyActiveEventsUpdated() after a successful
// submission; ActiveDisaster.js (or any other listener) calls
// onActiveEventsUpdated(callback) to refetch instantly, no page reload needed.
// Uses a plain window CustomEvent instead of React Context so it works across
// components regardless of where each one sits in the render tree.

export const ACTIVE_EVENTS_UPDATED_EVENT = 'drrdss:active-events-updated';

export function notifyActiveEventsUpdated() {
  window.dispatchEvent(new CustomEvent(ACTIVE_EVENTS_UPDATED_EVENT));
}

export function onActiveEventsUpdated(callback) {
  window.addEventListener(ACTIVE_EVENTS_UPDATED_EVENT, callback);
  return () => window.removeEventListener(ACTIVE_EVENTS_UPDATED_EVENT, callback);
}
